import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, RefreshCw, Home } from 'lucide-react';

const LoginError = ({ error, onRetry, onGoHome }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-md w-full"
      >
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-8">
          <div className="text-center mb-8">
            <div className="mx-auto w-16 h-16 bg-red-100 dark:bg-red-900/20 rounded-full flex items-center justify-center mb-4">
              <AlertCircle size={32} className="text-red-600 dark:text-red-400" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
              Ошибка входа
            </h1>
            <p className="text-gray-600 dark:text-gray-400">
              {error || 'Не удалось идентифицировать профиль пользователя'}
            </p>
          </div>

          <div className="space-y-4">
            {onRetry && (
              <button
                onClick={onRetry}
                className="w-full btn-primary flex items-center justify-center space-x-2"
              >
                <RefreshCw size={20} />
                <span>Попробовать снова</span>
              </button>
            )}
            
            {onGoHome && (
              <button
                onClick={onGoHome}
                className="w-full btn-secondary flex items-center justify-center space-x-2"
              >
                <Home size={20} />
                <span>Вернуться на главную</span>
              </button>
            )}
          </div>

          <div className="mt-8 text-center">
            <p className="text-sm text-gray-600 dark:text-gray-400">
              Если проблема повторяется, обратитесь к администратору
            </p>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default LoginError;

